export const ADVANCED_LABEL_DIRECTIONS = 'ADVANCED_LABEL_DIRECTIONS'
export const MED_REC_V2 = 'MED_REC_V2'